import { render, staticRenderFns } from "./AppFeaturesMetrics.vue?vue&type=template&id=af8afc92&"
import script from "./AppFeaturesMetrics.vue?vue&type=script&setup=true&lang=js&"
export * from "./AppFeaturesMetrics.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports